import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const fetchInboxDictionary = accountId => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/inbox-mass-offerings/dictionary`,
});

export const useFetchInboxDictionary = () => {
  const accountId = useSelector(selectors.getAccountId);

  const { payload, loading } = useQuery(fetchInboxDictionary(accountId));

  return { payload, loading };
};
